import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from '../button/button.module';
import { FormButtonModule } from '../button/form-button/form-button.module';
import { HighlightTextModule } from '../highlight-text/highlight-text.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

import { FlyoutOptionComponent } from './flyout-option.component';
import { ListboxComponent } from './listbox.component';

@NgModule({
  declarations: [FlyoutOptionComponent, ListboxComponent],
  imports: [CommonModule, ButtonModule, FormButtonModule, SvgIconModule, HighlightTextModule],
  exports: [FlyoutOptionComponent, ListboxComponent]
})
export class ListboxModule {}

export * from './flyout-option.component';
export * from './listbox.component';
